import "../app/flash"
import "../app/navigation"
import "../../../engines/notifications/javascript"
import "../app/account/upgrade-to-paid"
import "../app/shared/components/wistia-video"

// Make React available on window
import React from "react"
window.React = React
import ReactDOM from "react-dom"
window.ReactDOM = ReactDOM
